import { VInvoice } from "../views/account";

export interface ICustomerMail {
  companyName: string;
  branchName: string;
  sei: string;
  mei: string;
  amount: number;
  targetYear: number;
  targetMonth: number;
  targetMonthLastDay: number;
  targetClientCount: number;
  targetExtensionCount: number;
  targetExtensionYear: number;
  deadlineYear: number;
  deadlineMonth: number;
  deadlineDay: number;
  tookOverYear: number;
  tookOverMonth: number;
  tookOverClientCount: number;
  tookOverExtensionCount: number;
  tookOverExtensionYear: number;
  isExpired: boolean;
  unit_price: number;
  extension_price: number;
  old_price: number;
  old_extension_price: number;
}


export class TableItem {
  public sort: number; // TableListを昇順ソートを使用する際に使用する。
  public year: number;
  public month: number;
  public abstract: string;
  public amount: number;
  public price: number;

  constructor(sort: number, year: number, month: number, abstract: string, amount: number, price: number) {
    this.sort = sort;
    this.year = year;
    this.month = month;
    this.abstract = abstract;
    this.amount = amount;
    this.price = price;
  }

  public get useDate(): string {
    return `${this.year}年${this.month}月`;
  }

  public get total(): number {
    return this.price * this.amount;
  }
}

export class TableList {
  public static readonly TAX_RATE = 0.1;
  // 各摘要の単価
  public static readonly UNIT_PRICE = {
    BASIC: 100,
    OPTION1: 100, // 単価 = 延長年数 * OPTION1
  };

  private items: TableItem[] = [];

  public addItem(item: TableItem) {
    this.items.push(item);
  }

  public get totalAmount(): number {
    return this.items.reduce((total, item) => total + item.total, 0);
  }

  public get totalTax(): number {
    return Math.floor(this.totalAmount * TableList.TAX_RATE);
  }

  public get totalWithTax(): number {
    return Math.floor(this.totalAmount + this.totalAmount * TableList.TAX_RATE);
  }

  // 年と月で降順にソートし、sort プロパティで昇順ソートするメソッド
  public groupAndSortByDateDescending(): Array<{ key: string, items: TableItem[] }> {
    const groupedItems: { [key: string]: TableItem[] } = this.items.reduce((groups, item) => {
      const key = item.useDate;
      if (!groups[key]) {
        groups[key] = [];
      }
      groups[key].push(item);
      return groups;
    }, {} as { [key: string]: TableItem[] });

    // グループ化結果を年と月で降順にソート
    const sortedKeys = Object.keys(groupedItems).sort((a, b) => {
    const regex = /(\d+)年(\d+)月/;
    const [, yearA, monthA] = a.match(regex)!.map(Number);
    const [, yearB, monthB] = b.match(regex)!.map(Number);

    if (yearA !== yearB) {
        return yearB - yearA;
      } else {
        return monthB - monthA;
      }
    });

    // ソートされたキーに基づいてグループを再構築し、sort プロパティで昇順ソート
    return sortedKeys.map((key) => {
      const sortedItems = groupedItems[key].sort((a, b) => a.sort - b.sort);
      return { key, items: sortedItems };
    });
  }

  public insertInvoiceData(data: VInvoice) {
    // 基本料金の取得
    this.addItem(new TableItem(
      0,
      data.messageValues.targetYear,
      data.messageValues.targetMonth,
      `基本料金`,
      data.messageValues.targetClientCount,
      data.messageValues.unit_price,
    ));

    // 未支払い月?の基本料金の取得
    if (data.messageValues.tookOverYear > 0) {
      this.addItem(new TableItem(
        1,
        data.messageValues.tookOverYear,
        data.messageValues.tookOverMonth,
        `基本料金`,
        data.messageValues.tookOverClientCount,
        data.messageValues.old_price,
      ));

      // オプション料金(データ保管期間延長)
      if (data.messageValues.tookOverExtensionCount > 0) {
        this.addItem(new TableItem(
          100,
          data.messageValues.tookOverYear,
          data.messageValues.tookOverMonth,
          `オプション料金(${data.messageValues.tookOverExtensionYear}年延長)`,
          data.messageValues.tookOverExtensionCount,
          data.messageValues.old_extension_price * data.messageValues.tookOverExtensionYear,
        ));
      }
    }

    // オプション料金(データ保管期間延長)
    if (data.messageValues.targetExtensionCount > 0) {
      this.addItem(new TableItem(
        100,
        data.messageValues.targetYear,
        data.messageValues.targetMonth,
        `オプション料金(${data.messageValues.targetExtensionYear}年延長)`,
        data.messageValues.targetExtensionCount,
        data.messageValues.extension_price * data.messageValues.targetExtensionYear,
      ));
    }
  }

  public insertMailData(data: ICustomerMail) {
    // 基本料金の取得
    this.addItem(new TableItem(
      0,
      data.targetYear,
      data.targetMonth,
      `基本料金`,
      data.targetClientCount,
      data.unit_price,
    ));

    // 未支払い月?の基本料金の取得
    if (data.tookOverYear > 0) {
      this.addItem(new TableItem(
        1,
        data.tookOverYear,
        data.tookOverMonth,
        `基本料金`,
        data.tookOverClientCount,
        data.old_price,
      ));

      // オプション料金(データ保管期間延長)
      if (data.tookOverExtensionCount > 0) {
        this.addItem(new TableItem(
          100,
          data.tookOverYear,
          data.tookOverMonth,
          `オプション料金(${data.tookOverExtensionYear}年延長)`,
          data.tookOverExtensionCount,
          data.old_extension_price * data.tookOverExtensionYear,
        ));
      }
    }

    // オプション料金(データ保管期間延長)
    // オプション料金(データ保管期間延長)
    if (data.targetExtensionCount > 0) {
      this.addItem(new TableItem(
        100,
        data.targetYear,
        data.targetMonth,
        `オプション料金(${data.targetExtensionYear}年延長)`,
        data.targetExtensionCount,
        data.extension_price * data.targetExtensionYear,
      ));
    }
  }


}